<div *ngIf="formControl.value as productType" style="margin-bottom: 1rem;display: flex;">
  <p style="margin-top: 0;margin-right: 10px;">Code : {{productType.code}}</p>
  <a class="button-ghost" [routerLink]="['/extensions', 'product-type', productType.id]" target="_blank">
    {{ "common.details" | translate }}
    <clr-icon shape="link"></clr-icon>
  </a>
</div>
<!-- <select [formControl]="formControl" [compareWith]="compareFn">
  <option [ngValue]="null">Select a product type...</option>
  <option *ngFor="let item of productTypes$ | async" [ngValue]="item">
    <h3>{{ item.name }}</h3>
  </option>
</select> -->

<ng-select
  [items]="productTypes$ | async"
  appendTo="body"
  bindLabel="name"
  [addTag]="false"
  [multiple]="false"
  [hideSelected]="true"
  [trackByFn]="trackByFn"
  [minTermLength]="0"
  [loading]="isLoading"
  [typeahead]="input$"
  [formControl]="formControl"
>
  <ng-template ng-label-tmp let-item="item" let-clear="clear">
    <span class="item-row">
      <clr-icon shape="user" class="is-solid"></clr-icon
      ><span class="mx-1">{{ item.code }} - {{ item.name }}</span>
      <!-- <vdr-chip>{{ item.emailAddress }}</vdr-chip> -->
    </span>
  </ng-template>
  <ng-template ng-option-tmp let-item="item">
    <span class="item-row">
      <clr-icon shape="user" class="is-solid"></clr-icon
      ><span class="mx-1">{{ item.code }} - {{ item.name }}</span>
      <!-- <vdr-chip>{{ item.emailAddress }}</vdr-chip> -->
    </span>
  </ng-template>
</ng-select>
